import { formatAmount, formatDateTime } from "@utils";
import { Badge } from "@components";

const SalesOrderPayment = ({ salesOrders }) => {
  if (!salesOrders || !Array.isArray(salesOrders) || salesOrders.length === 0) return null;

  return (
    <div className="px-5 py-5 border-b">
      <div className="w-full flex mb-4 items-center">
        <p className="font-semibold m-0">Sales Orders</p>
      </div>
      <div className="relative z-0 border border-zinc-200 rounded-xl overflow-hidden bg-white">
        <div className="relative z-0 origin-top px-5 bg-zinc-50  flex flex-col divide-y divide-zinc-200">
          {salesOrders.map((order, index) => (
            <div key={order.id || index} className="py-4 flex flex-col gap-3">
              <div className="flex items-start">
                <div className="flex flex-col gap-0.5 justify-start grow items-stretch">
                  <span className="flex justify-between grow font-medium">
                    <span>{order.number}</span>
                    {order.reconciledOn && <Badge color="green">Updated in RBA</Badge>}
                    {(order.remainingAmount ?? order.grossAmount) && (
                      <span className="text-green-600">
                        {formatAmount(order.remainingAmount ?? order.grossAmount)}
                      </span>
                    )}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SalesOrderPayment;
